import { RouteObject, Navigate } from 'react-router-dom';

import AuthLayout from '@/layouts/AuthLayout';

import PortfolioPage from '@/pages/Portfolio';
import WelcomePage from '@/pages/Welcome';
import BuildingPage from '@/pages/Building';
import NewBuildingPage from '@/pages/NewBuilding';
import BuildingModelPage from '@/pages/BuildingModel';
import UnitPage from '@/pages/Unit';

import BlockMobileUsagePage from '@/pages/BlockMobileUsage';
import AccessDeniedPage from '@/pages/AccessDeniedPage';
import NotFoundPage from '@/pages/NotFound';

import Login from '@/containers/Auth/Login/Login';
import Register from '@/containers/Auth/Register/Register';

import PublicRoutes from '@/containers/PublicRoutes';
import PrivateRoutes from '@/containers/PrivateRoutes';
import PublicShareRoutes from '@/containers/PublicShareRoutes';
import SharedPricingReviewPage from '@/pages/SharedPricingReview';
import TodoPortfolio from '@/pages/TodoPortfolio';
import TodoBuildingPage from '@/pages/TodoBuildingPage';
import TodoUnitPage from '@/pages/TodoUnitPage';
import { ImportRentRollPage } from '@/pages/ImportRentRollPage';
import ProcessSettings from '@/pages/ProcessSettings';
import PricingWizardPage from '@/pages/PricingWizard';

const privateRoutes: RouteObject[] = [
  {
    path: '/',
    element: <PrivateRoutes />,
    errorElement: <NotFoundPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/portfolio" replace />,
      },
      {
        path: 'settings/process',
        element: <ProcessSettings />,
      },
      {
        path: '/google_connect_success',
        element: <PortfolioPage modal="google_connect" />,
      },
      {
        path: '/docusign_connect_success',
        element: <PortfolioPage modal="docusign_connect" />,
      },
      {
        path: 'portfolio',
        element: <PortfolioPage />,
      },
      {
        path: 'todo',
        element: <TodoPortfolio />,
      },
      {
        path: 'todo/:projectId/:buildingId',
        children: [
          {
            index: true,
            element: <TodoBuildingPage />,
          },
          {
            path: 'units/:unitId',
            element: <TodoUnitPage />,
          },
        ],
      },
      {
        path: 'm/projects/:projectId/:buildingId',
        children: [
          {
            index: true,
            element: <NewBuildingPage />,
          },
          {
            path: 'model',
            element: <BuildingModelPage />,
          },
          {
            path: 'rentroll',
            element: <ImportRentRollPage />,
          },
          {
            path: 'pricing',
            element: <NewBuildingPage defaultTab="pricing-tool" />,
          },
          {
            path: 'pricing/:pricingUnitId',
            element: <NewBuildingPage defaultTab="pricing-tool" />,
          },
          {
            path: 'draft-leases',
            element: <NewBuildingPage defaultTab="draft-leases" />,
          },
          {
            path: 'lease-analysis',
            element: <NewBuildingPage defaultTab="lease-analysis" />,
          },
          {
            path: 'pricing-wizard',
            element: <PricingWizardPage />,
          },
          {
            path: 'units/:unitId',
            element: <NewBuildingPage />,
            // children: [
            //   {
            //     index: true,
            //     element: <UnitPage />,
            //   },
            //   {
            //     path: 'group/:category',
            //     element: <UnitPage />,
            //   },
            //   {
            //     path: 'tab/:defaultTab',
            //     element: <UnitPage />,
            //   },
            // ],
          },
        ],
      },
      {
        path: 'projects/:projectId/:buildingId',
        children: [
          {
            index: true,
            element: <BuildingPage />,
          },
          {
            path: 'model',
            element: <BuildingModelPage />,
          },
          {
            path: 'rentroll',
            element: <ImportRentRollPage />,
          },
          {
            path: 'units/:unitId',
            element: <UnitPage />,
            children: [
              {
                index: true,
                element: <UnitPage />,
              },
              {
                path: 'group/:category',
                element: <UnitPage />,
              },
              {
                path: 'tab/:defaultTab',
                element: <UnitPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'access-denied',
    element: <AccessDeniedPage />,
  },
];

const publicRoutes: RouteObject[] = [
  {
    path: '/',
    element: <PublicRoutes />,
    errorElement: <NotFoundPage />,

    children: [
      {
        path: 'welcome',
        element: <WelcomePage />,
      },
      {
        path: 'block-mobile-usage',
        element: <BlockMobileUsagePage />,
      },
      {
        path: 'login',
        element: (
          <AuthLayout>
            <Login />
          </AuthLayout>
        ),
      },
      {
        path: 'register',
        element: (
          <AuthLayout>
            <Register />
          </AuthLayout>
        ),
      },
    ],
  },
];

// Share routes - accessible without authentication
const shareRoutes: RouteObject[] = [
  {
    path: '/review',
    element: <PublicShareRoutes />,
    children: [
      {
        path: ':shareId',
        element: <SharedPricingReviewPage />,
      },
    ],
  },
];

const routes: RouteObject[] = [...privateRoutes, ...publicRoutes, ...shareRoutes];

export default routes;
